import { FormField } from "@/types/Form.interface"
import Input from "@/types/Input.interface"
import { randomKey } from '@/utility/helpers'

export default {
    methods: {
        getDefaultInput(inputName: string): FormField {
            //  Grab our form default inputs
            const defInputs = this.$store.getters.formDefaultInputs

            //  Find this input from our form default inputs
            const foundInput = defInputs.find((x: Input) => x.name === inputName)

            //  If the input was found, then our new input is that, else, it's a custom one
            const newInput = foundInput || this.getCustomInput(inputName)

            //  Assign a random key to the id
            newInput.id = randomKey()

            //  Return our new input
            return newInput
        },
        getCustomInput(inputName: string): FormField {
            //  Find the extension (custom field) associated with the input
            const ext = this.$store.getters.getExtension(inputName)

            //  Grab the type from our extension (if it exists)
            const type = ext?.type.toUpperCase()

            //  Create our extension input
            const newInput: FormField = {
                id: randomKey(),
                type: type || "TEXT",
                name: inputName,
                label: inputName,
                path: inputName,
                cols: 12,
                order: 1,
                validate: 'max:300',
                required: true
            }

            //  If the input type is a 'DROPDOWN' add the select options to it
            if (type === "DROPDOWN") {
                newInput.options = ext.data
            }

            //  Generate and return new input data based on the input provided
            return newInput
        }
    }
}
